import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';

const StyledGlobalContainer = styled.div`
  position: fixed;
  top: 63px;
  left: 0;
  width: 100%;
  height: calc(100% - 190px);
  z-index: 3;
`;

const StyledContainer = styled.div`
  padding: 19px 0;
  background-color: ${theme.color.black};
  border-bottom: 1px solid ${rgba(theme.color.white, 0.1)};
`;

const StyledContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledButton = styled.button`
  width: 24px;
  height: 24px;

  svg path {
    fill: ${theme.color.gray200};
    transition: fill 0.25s ease;
  }

  ${props =>
    props.isActive &&
    `
    svg path {
      fill: ${theme.color.white};
    }
  `}
`;

const StyledInfoContainer = styled.div`
  width: 100%;
  max-height: 0;
  background-color: ${rgba(theme.color.black, 0.7)};
  opacity: 0;
  transition: 0.25s ease-in-out;
  transition-property: max-height, opacity;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${rgba(theme.color.gray, 0.5)};
    border-radius: 30px;
  }

  ${props =>
    props.isActive
      ? `
				max-height: calc(100% - 63px);
				opacity: 1;
			`
      : null}
`;

export {
  StyledGlobalContainer,
  StyledContainer,
  StyledButton,
  StyledContentWrapper,
  StyledInfoContainer,
};
